export const MINT_COMPONENT_HEADING_SUBTEXT = {
  FIXED: {
    heading: 'Fixed Edition',
    subText: 'Exclusive edition. Available in limited quantities.',
  },
  OPEN: {
    heading: 'Open Edition',
    subText: 'Exclusive edition. Available for a limited time.',
  },
  FIXED_VIP: {
    heading: 'Limited Edition',
    subText: 'Available in limited quantities. Priority seating.',
  },
  OPEN_VIP: {
    heading: 'Limited Edition',
    subText: 'Available for a limited time only. Priority seating.',
  },
  SAM: { heading: 'Sound Swap', subText: 'Open edition, then price starts to increase.' },
  MARKET: {
    heading: 'Secondary Market',
    subText: 'Sold out. Collect directly from the Secondary Market.',
  },
  MARKET_WITH_GA: {
    heading: 'Limited Edition',
    subText: 'Sold out. Collect directly from the Secondary Market.',
  },
  FOREVER: {
    heading: 'Forever Edition',
    subText: 'Patronage tier, unlimited and open forever.',
  },
  FALLBACK: {
    heading: 'Limited Edition',
    subText: 'Exclusive edition. Available in limited quantities.',
  },
} as const satisfies Record<Uppercase<string>, { heading: string; subText: string }>;
